
const messagePageActions = (props, attributes) => ({
  loaded() {
    attributes.setPageLoaded(true);
  },
});

export { messagePageActions };
